import script from "./Accessories.vue?vue&type=script&setup=true&lang=js"
export * from "./Accessories.vue?vue&type=script&setup=true&lang=js"

import "./Accessories.vue?vue&type=style&index=0&id=673cc72b&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673cc72b"]])

export default __exports__